import { gql } from '@apollo/client';

export default gql`
  fragment IntegrationSettings on Integration {
    settings {
      enableSso
      enableScim
      enableEnrich
      scimToken
      enableAllParents
      enabledParents
      enableSearch
      enabledSearchSources
      syncingRepos {
        name
        topicId
      }
      importOwnerId
      idpMetadata
    }
  }
`;
